import React, {useState, useMemo, useEffect} from "react";
import {
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    TableSortLabel,
    Autocomplete, Box, Typography, Collapse, Stack, IconButton
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {styled} from "@mui/material/styles";

const ExpandMore = styled((props) => {
    const {expand, ...other} = props;
    return <IconButton {...other} />;
})(({theme}) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
    variants: [
        {
            props: ({expand}) => !expand,
            style: {
                transform: 'rotate(0deg)',
            },
        },
        {
            props: ({expand}) => !!expand,
            style: {
                transform: 'rotate(180deg)',
            },
        },
    ],
}));




const UsersDanceTable = ({ users, events, filters, setFilters }) => {
    const [openCollapse, setOpenCollapse] = useState(false)


    const handleExpandClick = () => {
        setOpenCollapse(!openCollapse);
    };
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    // Обрабатываем пользователей
    const getUserDanceData = (user) => {
        if (!user.events) return [];
        return Object.entries(user.events).flatMap(([eventKey, event]) => {
            if (!event.danceSelections) return [];

            return Object.entries(event.danceSelections).flatMap(([dance, categories]) => {
                if (!categories) return [];
                return Object.entries(categories).map(([category, details]) => ({
                    userId: user._id,
                    name: user.name,
                    event: events.find(item => item?.event?.value === eventKey)?.event?.name ,
                    dance,
                    category,
                    role: details.role || "-",
                    partner: users.find(item => item._id === details.partner)?.name || "-",
                    class: details.class || "-",
                    number: event.number? event.number+"" : "-"
                }));
            });
        });
    };

    // Получаем все данные
    const allUsersData = users.flatMap(getUserDanceData);

    // Фильтрация
    const filteredData = allUsersData.filter((item) =>
        Object.entries(filters).every(([key, value]) =>
            value === "" || (item[key] && item[key].toLowerCase()?.includes(key !== 'event'?  value.toLowerCase() : value.event.name.toLowerCase()))
        )
    );

    // Сортировка
    const sortedData = useMemo(() => {
        if (!sortConfig.key) return filteredData;

        return [...filteredData].sort((a, b) => {
            const valueA = a[sortConfig.key] ?? "";
            const valueB = b[sortConfig.key] ?? "";

            // Определяем тип данных
            const isNumeric = !isNaN(valueA) && !isNaN(valueB);

            if (isNumeric) {
                return sortConfig.direction === "asc"
                    ? Number(valueA) - Number(valueB)
                    : Number(valueB) - Number(valueA);
            } else {
                return sortConfig.direction === "asc"
                    ? valueA.toString().localeCompare(valueB.toString())
                    : valueB.toString().localeCompare(valueA.toString());
            }
        });
    }, [filteredData, sortConfig]);


    // Доступные значения для фильтров
    const getUniqueValues = (key) => [...new Set(allUsersData.map((item) => item[key]))];

    // Обработчик сортировки
    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc"
        }));
    };

    return (
        <Box
        >
            {/* Фильтры */}
            <Stack direction="row" spacing={2}>
            <Typography variant="h6">Фильтры</Typography>
            <ExpandMore
                expand={openCollapse}
                onClick={handleExpandClick}
                aria-expanded={openCollapse}
                aria-label="show more"
            ><ExpandMoreIcon/>
            </ExpandMore>
            </Stack>
            <Collapse in={openCollapse} timeout="auto" unmountOnExit>
            <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap" }}>

                <Autocomplete
                    key={'event'}
                    options={events.map((ev) => ev.event.name) }
                    value={filters['event']?.event?.name}
                    onChange={(event, newValue) =>
                        setFilters({
                            ...filters,
                            dance:"",
                            category:"",
                            class:"",
                            event: events.find((ev)=>ev.event.name === newValue) || ""
                        })}
                    renderInput={(params) => <TextField {...params} label={'Событие'} size="small" />}
                    style={{ width: "100%" }}
                />

                <Autocomplete
                    disabled={!filters['event']?.event?.name}
                    key={'dance'}
                    options={filters?.event?.dancesList}
                    value={filters['dance']}
                    onChange={(event, newValue) =>
                        setFilters({
                            ...filters,
                            category:"",
                            class:"",
                            dance: newValue || ""
                    })}
                    renderInput={(params) => <TextField {...params} label={'Танец'} size="small" />}
                    style={{ width: "100%" }}
                />

                <Autocomplete
                    disabled={!filters['dance']}
                    key={'category'}
                    options={filters?.event?.categoriesList?.[filters?.dance]?.map(c => c?.name)}
                    value={filters['category']}
                    onChange={(event, newValue) => setFilters({
                        ...filters,
                        class:"",
                        category: newValue || ""
                    })}
                    renderInput={(params) => <TextField {...params} label={'Категория'} size="small" />}
                    style={{ width: "100%" }}
                />

                <Autocomplete
                    disabled={!filters['category']}
                    key={'class'}
                    options={filters?.event?.classList?.[filters?.dance]?.[filters?.category]}
                    value={filters['class']}
                    onChange={(event, newValue) => setFilters({
                        ...filters,
                        class: newValue || ""
                    })}
                    renderInput={(params) => <TextField {...params} label={'Класс'} size="small" />}
                    style={{ width: "100%" }}
                />


                {[["name","Имя"]].map((field) => (
                    <Autocomplete
                        key={field[0]}
                        options={getUniqueValues(field[0])}
                        getOptionLabel={(option) => option}
                        value={filters[field[0]]}
                        onChange={(event, newValue) => setFilters({ ...filters, [field[0]]: newValue || "" })}
                        renderInput={(params) => <TextField {...params} label={field[1]} size="small" />}
                        style={{ width: "100%" }}
                    />

                ))}
                {/* Фильтр для роли */}
                <FormControl size="small" style={{ width: "100%" }}>
                    <InputLabel>Роль</InputLabel>
                    <Select
                        value={filters.role}
                        onChange={(e) => setFilters({ ...filters, role: e.target.value })}
                    >
                        <MenuItem value="">Все</MenuItem>
                        <MenuItem value="leader">Leader</MenuItem>
                        <MenuItem value="follower">Follower</MenuItem>
                    </Select>
                </FormControl>
            </div>
            </Collapse>

            {/* Таблица */}
            <TableContainer
sx={{
    margin: "auto",
    mt: 0,
    p: 0,
    overflow: 'auto',
    height: (window.innerHeight - 100) + 'px'}}
                component={Paper}>
                <Table
                size={"small"}
                >
                    <TableHead>
                        <TableRow>
                            {[["name","Имя"], ["event","Событие"], ["dance","Танец"],["category","Категория"],["role","Роль"],["partner","Партнер"],["class","Класс"], ["number","Номер"]].map((col) => (
                                <TableCell key={col[0]}>
                                    <TableSortLabel
                                        active={sortConfig.key === col[0]}
                                        direction={sortConfig.direction}
                                        onClick={() => handleSort(col[0])}
                                    >
                                        {col[1]}
                                    </TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedData.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.event}</TableCell>
                                <TableCell>{row.dance}</TableCell>
                                <TableCell>{row.category}</TableCell>
                                <TableCell>{row.role}</TableCell>
                                <TableCell>{row.partner}</TableCell>
                                <TableCell>{row.class}</TableCell>
                                <TableCell>{row.number}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default UsersDanceTable;
